import pLimit from 'p-limit';

// Throttle concurrent market-listings fetches. /seasons mounts one listings query
// per event, so without this the page would fire a request per card at once. Lives
// in its own module so both the listings query atom (data/atoms) and the season
// progress UI (SeasonPricer, SeasonEvents.Header) can share it without a cycle.
export const marketListingsLimit = pLimit(5);
